export const formatDate = (dateString) => {
    const timeString12hr = new Date(
        '1970-01-01T' + dateString.split('T')[1] + 'Z'
    ).toLocaleTimeString('en-US', {
        timeZone: 'UTC',
        hour12: true,
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric'
    });
    return `${dateString.split('T')[0]} ${timeString12hr}`;
  };